import { render, staticRenderFns } from "./PreviewOrder.vue?vue&type=template&id=564f7128&"
import script from "./PreviewOrder.vue?vue&type=script&lang=ts&"
export * from "./PreviewOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports